export const validation = {
	alphachar: function (value) {
		if (/^[a-zA-Z]*$/g.test(value)) return true;
		return false;
	},
	firstname: function (value) {
		if (value !== '') return true;
		return false;
	},
	lastname: function (value) {
		if (value !== '') return true;
		return false;
	},
	email: function (value) {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) return true;
		return false;
	},
	password: function (value) {
		const lowercase = value.match(/[a-z]/g);
		const uppercase = value.match(/[A-Z]/g);
		const number = value.match(/[0-9]/g);
		const length = value.length >= 8;
		const criteria = [lowercase, uppercase, number, length];
		const increment = Math.ceil(100 / criteria.length);
		const strengthUI = document.querySelector('[data-el="password-strength"]');
		let score = 0;

		if (strengthUI) {
			criteria.forEach((valid) => {
				if (valid) score = score + increment;
			});

			if (value && value != '') {
				if (score >= 25) {
					strengthUI.classList.add('text--info');
					strengthUI.classList.remove('text--warning', 'text--green', 'text--error');
					strengthUI.innerText = 'Weak';
				} else {
					strengthUI.classList.remove('text--info');
					strengthUI.classList.add('text--error');
					strengthUI.innerText = 'No Password';
				}

				if (score >= 50) {
					strengthUI.classList.add('text--warning');
					strengthUI.classList.remove('text--info', 'text--green', 'text--error');
					strengthUI.innerText = 'Medium';
				} else {
					strengthUI.classList.remove('text--warning');
					strengthUI.innerText = 'Weak';
				}

				if (score >= 100) {
					strengthUI.classList.add('text--green');
					strengthUI.classList.remove('text--info', 'text--warning', 'text--error');
					strengthUI.innerText = 'Strong';
				} else {
					strengthUI.classList.remove('text--green');
					strengthUI.innerText = 'Medium';
				}
			} else {
				strengthUI.classList.remove('text--warning', 'text--green', 'text--info');
				strengthUI.classList.add('text--error');
				strengthUI.innerText = 'No Password';
			}
		}

		if (!lowercase) {
			return false;
		}
		if (!uppercase) {
			return false;
		}
		if (!number) {
			return false;
		}
		if (!length) {
			return false;
		}

		return true;
	},
	confirm: function () {
		const password = document.querySelector('main input[name="customer[password]"');
		let confirmPassword = document.querySelector('main input[name="customer[confirm_password]"');
		if (!confirmPassword) {
			confirmPassword = document.querySelector('main, input[name="customer[password_confirmation]');
		}

		if (password.value === confirmPassword.value) return true;
		return false;
	}
};
